var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountEntityName } from '../../../../backend/features/accounts/shared';
import { showImageUploadDialog } from '../../../../ui/components/UploadImageDialog';
import { allowManageProfilePicture } from '../../../../ui/features/accounts/utils';
import { useUserState } from '../../../../ui/hooks';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { gradients } from '@juvare/common-web-ui/ColorPaper';
import { handleErrorSnackbar, showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useAttachmentClient } from '@juvare/platform-sdk-react/ui/hooks';
import { getImageDataUrl } from '@juvare/platform-sdk-react/ui/utils';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import avatarPlaceholder from '../../../assets/avatarPlaceholder.svg';
export const AccountProfilePicture = ({ accountId, firstName, lastName, orgMembership, hideUpload, }) => {
    const { t } = useContactManagementTranslation();
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const accountAttachmentStorage = useAttachmentClient();
    const [userProfilePicture, setUserProfilePicture] = React.useState();
    const [reloadLogo, setReloadLogo] = React.useState();
    const attachmentClient = useAttachmentClient();
    React.useEffect(() => {
        accountAttachmentStorage
            .list({ entity: 'account', entityId: accountId })
            .then((response) => {
            const foundUserProfilePicture = response.find((attachment) => attachment.key === 'userProfilePicture');
            if (foundUserProfilePicture) {
                getImageDataUrl(attachmentClient, 'account', accountId, 'userProfilePicture')
                    .then(setUserProfilePicture)
                    .catch(handleErrorSnackbar);
            }
            else {
                setUserProfilePicture(undefined);
            }
        })
            .catch(handleErrorSnackbar);
    }, [accountId, accountAttachmentStorage, reloadLogo, attachmentClient]);
    return (React.createElement(Box, { sx: { position: !hideUpload ? 'relative' : undefined }, "data-test": 'profile-picture' },
        userProfilePicture ? (React.createElement(Avatar, { sx: {
                position: 'static',
                height: '180px',
                width: '180px',
            }, src: userProfilePicture, "data-test": 'profile-logo' })) : (React.createElement(Avatar, { sx: {
                position: 'static',
                height: '180px',
                width: '180px',
                bgcolor: gradients['blue-light-angle'],
            }, "data-test": 'profile-logo' },
            React.createElement(Box, { sx: { position: 'relative' } },
                React.createElement("img", { style: { width: '100%' }, src: avatarPlaceholder, alt: t('common.avatarPlaceholderAlt') }),
                React.createElement(Typography, { variant: 'body1', sx: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '28px',
                        fontWeight: 400,
                        lineHeight: '36px',
                        letterSpacing: '0px',
                    } },
                    lastName.slice(0, 1),
                    firstName.slice(0, 1))))),
        !hideUpload && allowManageProfilePicture({ userState, accountId, orgMembership }) && (React.createElement(IconButton, { color: 'primary', sx: (theme) => ({
                background: theme.palette.background.default,
                bottom: 0,
                position: 'absolute',
                right: 0,
                '&:hover': {
                    backgroundColor: theme.palette.background.default,
                },
            }), onClick: () => {
                showAccountProfilePictureDialog(accountId, accountAttachmentStorage, t, () => {
                    setUserProfilePicture(undefined);
                    setReloadLogo({});
                }, settings.allowWebcam);
            }, "data-test": 'upload-avatar-button', "aria-label": t('panels.accounts.uploadImage') },
            React.createElement(AddAPhotoOutlinedIcon, null)))));
};
export function showAccountProfilePictureDialog(accountId, accountAttachmentStorage, t, onSaved, allowWebcam) {
    showImageUploadDialog({
        title: t('panels.accounts.uploadImage'),
        label: t('panels.accounts.image'),
        allowedMaxSize: 2097152,
        previewProps: { maxHeight: 180, maxWidth: 180, borderRadius: 50 },
        webcam: allowWebcam,
        onSave: (blob) => __awaiter(this, void 0, void 0, function* () {
            if (blob) {
                try {
                    yield accountAttachmentStorage.post({
                        entity: accountEntityName,
                        entityId: accountId,
                        key: 'userProfilePicture',
                        content: blob,
                        contentLength: blob.size,
                        contentType: blob.type,
                    });
                    showInfoSnackbar({ message: t('common.saved') });
                    onSaved();
                }
                catch (error) {
                    return handleErrorSnackbar(error);
                }
            }
            else {
                return Promise.resolve();
            }
        }),
    });
}
